import { useQuery } from "@tanstack/react-query";
import { api } from "../services/api";
import { Button, Card } from "../components/ui";
import { toastSuccess } from "../stores/ui";
import type { PublicSettings } from "../types";
import { BRAND_HUB, BRAND_LOGO, BRAND_NAME } from "../brand";

export function LoginPage() {
  const { data } = useQuery({
    queryKey: ["public-settings"],
    queryFn: () => api<PublicSettings>("/api/settings/public"),
  });

  async function bypass() {
    try {
      await api("/api/auth/dev-bypass", { method: "POST" });
      toastSuccess("Signed in");
      window.location.href = "/";
    } catch {
      /* api() already shows an error toast */
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md text-center">
        <img src={BRAND_LOGO} alt={BRAND_NAME} className="mx-auto h-24 w-24 object-contain" />
        <p className="mt-4 text-[11px] uppercase tracking-[0.22em] text-cyan">{BRAND_NAME}</p>
        <h1 className="mt-2 text-2xl font-semibold">{data?.hubName ?? `${BRAND_HUB} Hub`}</h1>
        <p className="mt-2 text-sm text-zinc-400">Sign in with Discord to continue.</p>
        <a href="/api/auth/discord">
          <Button className="mt-6 w-full">Continue with Discord</Button>
        </a>
        {data?.devAuthBypass ? (
          <Button variant="ghost" className="mt-3 w-full" onClick={() => void bypass()}>
            Development bypass
          </Button>
        ) : null}
      </Card>
    </div>
  );
}
